const { connect } = require('react-redux');
const selectComponent = require('../component/selectComponent').default;
const { actions } = require('../../../../reducers').default;
const { modalType, sceneType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    return {
        isModalOpen: state.screenState.modal === modalType.MODAL_SELECT,
        soundEnable: state.appState.soundEnable
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleBackClick: () => {
            dispatch(actions.modalDisable());
        },
        handleStartClick: (type, name) => {
            dispatch(actions.startGame(type, name));
            dispatch(actions.sceneTransition(sceneType.SCENE_GAME));
            // set Charactor
            // start game
        }
    };
};

export const SelectContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(selectComponent);